export default __webpack_public_path__ + "static/media/FSK_CarryOut_Menu.4f0b62e0.pdf";